import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import marketChart from "../../../Assets/Images/market_chart.svg";
import useReveal from "../useReveal";
import "./Style.scss";

const pillars = [
  {
    icon: "fa-eye",
    title: "Clarity",
    text: "Straightforward products and processes so every step feels clear.",
  },
  {
    icon: "fa-bolt",
    title: "Speed",
    text: "Digital account opening and responsive trading tools when you need them.",
  },
  {
    icon: "fa-layer-group",
    title: "Simplicity",
    text: "A focused broking experience without clutter or complexity.",
  },
];

const AboutContainer = () => {
  const revealRef = useReveal();

  return (
    <section className="homeAbout">
      <Container className="homeAbout__inner homeReveal" ref={revealRef}>
        <Row className="align-items-center g-4 g-lg-5">
          <Col lg={5}>
            <div className="homeAbout__visual">
              <img src={marketChart} alt="" className="homeAbout__chart" />
            </div>
          </Col>
          <Col lg={7}>
            <p className="homeAbout__eyebrow">About us</p>
            <h2 className="homeAbout__title">Algoquant Global</h2>
            <p className="homeAbout__lead">
              A stockbroking platform focused on making market access simple and
              reliable. We combine a modern trading experience with transparent
              processes and dedicated support — so opening and managing your
              account stays straightforward.
            </p>
            <div className="homeAbout__pillars">
              {pillars.map((item) => (
                <div className="homeAbout__pillar" key={item.title}>
                  <span className="homeAbout__icon" aria-hidden="true">
                    <i className={`fas ${item.icon}`} />
                  </span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutContainer;
